// extracted by mini-css-extract-plugin
export default {"overlay":"VH-z","bodyOpen":"WH-z","content":"XH-z","header":"YH-z","close":"ZH-z","closeNoHeading":"_H-z"};